import * as Hooks from 'preact/hooks';
import * as Actions from '../../store/actions/app';
import { useDispatch, useSelector } from '../../store/redux';
import * as Selectors from '../../store/selectors';

export const useSelectionsChangeMetrics = (
    selectionsChangeInfo: {
        isTracking: boolean | undefined;
        solutionMode: string | undefined;
        selectionType: string | undefined;
        isCompatible: boolean | undefined;
    },
    setSelectionsChangeInfo: Hooks.StateUpdater<{
        isTracking: boolean | undefined;
        solutionMode: string | undefined;
        selectionType: string | undefined;
        isCompatible: boolean | undefined;
    }>,
) => {
    const dispatch = useDispatch();

    const basketValue = useSelector(Selectors.Basket.basket);

    const startMarks = performance.getEntriesByName('change-selection-start', 'mark');
    const endMarks = performance.getEntriesByName('change-selection-end', 'mark');

    if (selectionsChangeInfo.isTracking === true && startMarks.length === 0) {
        performance.mark('change-selection-start');
    }

    if (selectionsChangeInfo.isTracking === false && startMarks.length !== 0) {
        performance.mark('change-selection-end');
    }

    Hooks.useEffect(() => {
        if (basketValue && startMarks.length !== 0 && endMarks.length !== 0) {
            const measure = Math.round(
                performance.measure(
                    'change-selection-duration',
                    'change-selection-start',
                    'change-selection-end',
                ).duration,
            ).toFixed(2);

            performance.clearMarks('change-selection-start');
            performance.clearMarks('change-selection-end');
            performance.clearMeasures('change-selection-duration');

            dispatch(
                Actions.changeSelectionsLoadingDurationAction({
                    measure: measure,
                    solutionMode: selectionsChangeInfo.solutionMode || 'No Solution Found',
                    selectionType: selectionsChangeInfo.selectionType || 'No Selection Found',
                    isCompatible:
                        selectionsChangeInfo.isCompatible?.toString() || 'No Compatibility Found',
                }),
            );

            setSelectionsChangeInfo({
                isTracking: undefined,
                selectionType: undefined,
                solutionMode: undefined,
                isCompatible: undefined,
            });
        }
    }, [basketValue, endMarks]);
};
